<template>
  <router-view />
</template>
<script>
export default {
  created() {
    this.$router.afterEach((to) => {
      document.title = "PDE Timetracker · " + this.$t(to.meta.title) || "PDE Timetracker";
    });
  },
};
</script>
